
import Vue from "vue";
import { mapActions, mapMutations } from "vuex";

export default Vue.extend({
  data() {
    return {
      email: "",
      firstName: "",
      lastName: "",
      submitted: false,
      usedEmail: false,
      requesting: false,
    };
  },
  methods: {
    ...mapMutations({
      setLoading: "setLoading",
    }),
    ...mapActions({
      loginGuest: "user/loginGuest",
      checkEmail: "user/checkEmail",
    }),
    isValidEmail(email) {
      let validEmail = this.$refs.guessEmail as HTMLInputElement;
      return validEmail ? validEmail.checkValidity() : false;
    },
    async submitLogin() {
      if (
        this.email &&
        this.firstName &&
        this.lastName &&
        this.isValidEmail(this.email) &&
        !this.usedEmail
      ) {
        let guest = await this.loginGuest({
          email: this.email,
          firstName: this.firstName,
          lastName: this.lastName,
        });
        if (guest) {
          //emit confirmation
          this.$emit("confirmationMade");
          this.submitted = false;
        }
      } else {
        this.submitted = true;
      }
    },
  },
  watch: {
    async email(newVal) {
      if (this.isValidEmail(newVal) && !this.requesting) {
        this.requesting = true;
        let used = await this.checkEmail({ email: newVal });
        this.requesting = false;
        if (!used) {
          this.usedEmail = true;
        } else {
          this.usedEmail = false;
        }
      }
    },
  },
});
